var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-history",
    "data-name": "Icon awesome-history",
    d: "M15.563,8.048A7.5,7.5,0,0,1,3.356,13.9.725.725,0,0,1,3.3,12.825l.341-.341a.727.727,0,0,1,.964-.06A5.565,5.565,0,1,0,4.25,4.008L5.785,5.543a.484.484,0,0,1-.342.826h-4.4a.484.484,0,0,1-.484-.484v-4.4a.484.484,0,0,1,.826-.342L2.882,2.64A7.5,7.5,0,0,1,15.563,8.048Zm-5.471,2.383.3-.382a.726.726,0,0,0-.127-1.019L9.03,8.073V4.917A.726.726,0,0,0,8.3,4.192H7.821a.726.726,0,0,0-.726.726v4.1l1.978,1.539A.726.726,0,0,0,10.091,10.431Z",
    transform: "translate(-0.563 -0.563)",
    fill: "#1492e6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/Refresh.c0ba2bebd1a0e297baa62ef96417979f.svg";
export { ForwardRef as ReactComponent };